import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { GlobalConstants } from "../../global-constants";
import { PlatformService } from "../platform/platform.service";
import { Injectable } from "@angular/core";
import { Revista } from "@src/app/models/interfaces/revista.interface";

@Injectable()
export class RevistaService {
  private readonly API_URL: string;
  private readonly constantesGlobales: any;
  private readonly isCartaEditorial = new BehaviorSubject<boolean | null>(null);
  public isCartaEditorial$: Observable<boolean> = this.isCartaEditorial.asObservable();
  constructor(
    private readonly httpClient: HttpClient,
    private readonly platformService: PlatformService,
  ) {
    const host = this.platformService.getLocationHostname();
    this.constantesGlobales = new GlobalConstants(host);
    this.API_URL = this.constantesGlobales.urlApi;
  }

  /**
   * Obtiene una lista de revistas desde el servidor.
   *
   * @param idAmbito - El identificador del ámbito para filtrar las revistas.
   * @param id - (Opcional) El identificador específico de una revista.
   * @returns Un observable que emite la respuesta del servidor con la lista de revistas.
   */
  public getRevistas(idAmbito: number, id: number = null): Observable<Revista[]> {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json, text/javascript, */*; q=0.01",
    });

    let body = new HttpParams().set("id_ambito", idAmbito);
    if (id !== null) {
      body = body.set("id", id);
    }

    return new Observable<Revista[]>((observer) => {
      this.httpClient.get<Revista[]>(this.API_URL + "/getRevistas", { headers: headers, params: body }).subscribe({
        next: (data) => {
          observer.next(data);
          observer.complete();
        },
        error: (error) => {
          observer.error(error);
        },
      });
    });
  }
}
